import React from 'react'

export const Banner = () => {
  return (
    <>
    <section className="main coffeemain">
    <div className="container coffeeBannerAbout my-4">
        <div className="row">
            <div className="col-md-12 coffeeBennercolAbout">
            <h1>ABOUT US</h1>
            </div>
        </div>
    </div>
    </section>
    </>
  )
}
